var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 900,
    viewBox: "0 0 1200 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .outline { fill: none; stroke: #0e0e0e; stroke-width: 64; stroke-linejoin: miter; stroke-linecap: butt; }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "outline",
    d: "     M 80,780     V 400     H 400     V 220     H 720     V 480     H 1040     V 780   "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankrLogo);
export default __webpack_public_path__ + "static/media/rankr_logo.345204d69a5de13ff7fee35d3a49ecec.svg";
export { ForwardRef as ReactComponent };